import { Injectable } from "@angular/core";
import { DocMetadataHandler } from "./add-doc-metadata.interface";
import { DocMetadata, DocMetadataDto, DocMetadataInfo } from "../model/doc-metadata";
import { ClaimDocMetadata } from "src/app/claims-view/model/claims-view.model";



@Injectable()
export class ClaimBulkDocMetadataHandler extends DocMetadataHandler {

    claimDocMetadata: ClaimDocMetadata[] = [];
    lockedMetadataMap: Map<string, boolean> = new Map();
    selectedClaimsNum: number = 0;
    initialSelections: {[group: string]: DocMetadata[] | DocMetadata | null} = {};
    override extractDocMetadataInfo(data: DocMetadataDto[]): DocMetadataInfo {

            const docMetadataInfo = super.extractDocMetadataInfo(data);

            this.initialSelections = structuredClone(this.selections);


            return docMetadataInfo;

    }   
    override initializeGroupSelections(data: DocMetadataDto, docMetadataList: DocMetadata[]): boolean {
        
        super.initializeGroupSelections(data,docMetadataList);
        if (data.default_value !== null) {
            
            return true;
        }
        let currentGroupMetadataValues = this.claimDocMetadata.filter(docMetadata => docMetadata.fieldLabel == data.field_label);
        //this.selections[data.field_name] = data.is_multivalued ? [] : null;

        if (currentGroupMetadataValues.length > 0 && this.selectedClaimsNum == currentGroupMetadataValues.length) {
            
            
            let metadataOptionsToSelect = docMetadataList.filter((data) => currentGroupMetadataValues[0].fieldValues.find((metadataValue) => data.fieldLabel == metadataValue));
            
            // select only if all metadata values are unique
            let hasSameValues: boolean = true;

            for (let i=1; i<currentGroupMetadataValues.length; i++) {
                
                let currentClaimMetadataOptions = docMetadataList.filter((data) => currentGroupMetadataValues[i].fieldValues.find((metadataValue) => data.fieldLabel == metadataValue));
                let areEqual = this.isEqualDocMetadata(metadataOptionsToSelect, currentClaimMetadataOptions);
 

                if (!areEqual) {

                    hasSameValues = false;
                    break;
                }
            }
            if (hasSameValues) {

                this.selections[data.field_name] = data.is_multivalued ? metadataOptionsToSelect : metadataOptionsToSelect[0];
            } else {
                // add to lock map
                if (this.selectedClaimsNum > 1) {
                    
                    this.lockedMetadataMap.set(data.field_name, true);
                }
            }
        } else {
            if (currentGroupMetadataValues.length > 0 && this.selectedClaimsNum > 1) {
                this.lockedMetadataMap.set(data.field_name, true);
            }
        }
        
        return false;
    }
    override getDocMetadataToAdd(): { [key: string]: string[]; } | null {


        let groups = Object.keys(this.selections);

        if (!groups || groups.length == 0) {

            return null;
        }

        let metadata: { [key: string]: string[] } | null = null;
        for (let group of groups) {

            let docMetadataValues = this.selections[group];
            let initialDocMetadataValues = this.initialSelections[group];

            if (Array.isArray(docMetadataValues)) {

                if (!this.isEqualDocMetadata(docMetadataValues, initialDocMetadataValues as DocMetadata[])) {
                    if (metadata == null) {
                        metadata = {};
                    }
                    let metadataValues: string[] = docMetadataValues.map(metadata => metadata.fieldValue);
                    metadata[group] = metadataValues;
                }

            } else if (docMetadataValues != null || initialDocMetadataValues != null) {
                if ((docMetadataValues && !initialDocMetadataValues) || (!docMetadataValues && initialDocMetadataValues) || ((docMetadataValues as DocMetadata).fieldLabel != (initialDocMetadataValues as DocMetadata).fieldLabel)) {

                    if (metadata == null) {
                        metadata = {};
                    }
                    let metadataValues: string[] = [];
                    if (docMetadataValues) {
                        metadataValues = [docMetadataValues.fieldValue];
                    }
                    metadata[group] = metadataValues;
                }

            }

        }
        return metadata;
    }

    isEqualDocMetadata(firstDocMetadata:DocMetadata[], secondDocMetadata: DocMetadata[]) {
        
        for (let j = 0; j < secondDocMetadata.length; j++) {

            //comparing metadata options
            let foundMetadataOption = firstDocMetadata.find((metadataOption) => metadataOption.fieldLabel == secondDocMetadata[j].fieldLabel);
            if (!foundMetadataOption) {
                return false;
                
            }
        }
        return firstDocMetadata.length == secondDocMetadata.length;
    }


    
    hasLock(groupName: string) {
        
        return this.lockedMetadataMap.has(groupName);
    }

    getLockValue(groupName: string) {
        
        return this.lockedMetadataMap.get(groupName);
    }

    toggleLockValue(groupName: string) {
        const lockValue = !this.lockedMetadataMap.get(groupName);
        this.lockedMetadataMap.set(groupName, lockValue);

        if (lockValue) {
            const initialSelection = this.initialSelections[groupName];
            this.selections[groupName] = Array.isArray(initialSelection)
                ? [...initialSelection]
                : initialSelection;
        }
    }

}